// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story","5177":"home"}[chunkId] || chunkId) + "-" + {"3093":"70023b909d4b0ac92f7d","3180":"29f0e78cd2d7125b2ade","5177":"b66ebc11cf42442a7381","5824":"c80769426ef071d2fd97"}[chunkId] + ".css";
};